<template>
  <div class="monthlyProfit">
    <v-container class="pt-6">
      <v-btn text color="pink" @click="$func.goBack()">
        <v-icon small class="mr-2">fa-chevron-left</v-icon>
        返回
      </v-btn>
      <div class="table wrapper">
        <v-row class="table-header">
          <v-col>日期</v-col>
          <v-col>數量</v-col>
          <v-col>總桃子</v-col>
        </v-row>
        <v-row class="table-content" v-for="statistic in statistics" v-if="statistic">
          <v-col>{{ statistic.date }}</v-col>
          <v-col>{{ statistic.types.all.sold_out }}</v-col>
          <v-col>
            <div class="peach"></div>
            {{ statistic.types.all.sold_peaches }}
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      dates: [this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')],
      statistics: Array(12)
    }
  },
  created() {
    this.getStatistic()
  },
  methods: {
    async getStatistic() {
      for (let i = 0; i < 12; i++) {
        let start = this.$moment().startOf('month').subtract(i, 'month').format('YYYY-MM-DD')
        let end = this.$moment(start).endOf('month').format('YYYY-MM-DD')
        this.axios(`/portal/statistics?start=${start}&end=${end}`).then(response => {
          let all_sold_out = Object.values(response.data.types).reduce((prev, type) => {
            return prev + parseInt(type.sold_out)
          }, 0)
          let all_sold_peaches = Object.values(response.data.types).reduce((prev, type) => {
            return prev + parseInt(type.sold_peaches)
          }, 0)
          response.data.date = start.slice(0, 7)
          response.data.types.all = {sold_out: all_sold_out, sold_peaches: all_sold_peaches}
          this.$set(this.statistics, i, response.data)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.monthlyProfit {
  .table {
    margin-top: 8px;
    .date-picker {
      padding: 16px;
      max-width: 300px;
    }
    .col {
      overflow: unset;
    }
  }
}
</style>